var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoodleTwo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.068,
    height: 67.756,
    viewBox: "0 0 47.068 67.756",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_004",
    "data-name": 4,
    transform: "translate(-4812.426 1944.588)",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_353",
    "data-name": "Trazado 353",
    d: "M0,0C7.613,6.754,19.117,5.237,29.277,4.665c2.433-.143,4.98-.172,7.1,1s3.52,3.978,2.347,6.1c-1.6,2.919-7.155,3.892-6.182,7.1,5.438,4.207,13.022,3.749,19.661,5.466s13.451,8.643,10.16,14.681",
    transform: "matrix(-0.087, 0.996, -0.996, -0.087, 4857.222, -1940.659)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_354",
    "data-name": "Trazado 354",
    d: "M4819.75-1934.028l16.721-9.223,1.215,18.14",
    transform: "translate(21.06 2.471)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoodleTwo);
export default __webpack_public_path__ + "static/media/doodle_two.bc33f6f411ea6c973e78eaf52bab8ddc.svg";
export { ForwardRef as ReactComponent };